import React, { Component } from "react";
import moment from "moment-timezone";
import "../../public/css/common/date_range_filter.css";

/**
 * The "Select Date <from> To <to> Find Clear" bar shared by every list that
 * filters on a submission / order date range - the retailer dashboard and
 * transaction history, the diagnostics dashboard and the admin product
 * approval screens.
 *
 * Each of those pages used to carry its own copy of the markup, so the same
 * filter looked and behaved slightly differently on each one (native inputs
 * here, react-datepicker there, "find" vs "Search", "Clear" vs
 * "Clear Filter"). Everything page specific is a prop; the layout, the input
 * type and the button styling are not.
 *
 * Props:
 *   startDate / endDate  - YYYY-MM-DD strings ("" when unset)
 *   onStartDateChange / onEndDateChange - receive the raw change event
 *   onFind / onClear     - click handlers
 *   label                - leading label, defaults to "Select Date"
 *   findLabel/clearLabel - button text, default "Find" / "Clear"
 *   maxDate              - upper bound, defaults to today (pass null to lift
 *                          it on pages that list future dates)
 *   startId / endId      - input ids; the older pages read these with jQuery
 *   canFind / canClear   - false greys the button out and drops the handler
 *   className            - extra classes on the wrapper for page layout
 */
class DateRangeFilter extends Component {
  renderButton(cssKey, text, handler, enabled) {
    const isEnabled = enabled !== false;

    return (
      <div
        className={`rgt_arrow_btn ${cssKey}${isEnabled ? "" : " is_disabled"}`}
        onClick={isEnabled ? handler : undefined}
      >
        <p>{text}</p>
      </div>
    );
  }

  render() {
    const {
      startDate = "",
      endDate = "",
      onStartDateChange,
      onEndDateChange,
      onFind,
      onClear,
      label = "Select Date",
      findLabel = "Find",
      clearLabel = "Clear",
      maxDate,
      startId = "start_date",
      endId = "end_date",
      canFind,
      canClear,
      className = "",
    } = this.props;

    // undefined means "not passed" - default to today; an explicit null lifts
    // the bound entirely.
    const max =
      maxDate === undefined ? moment().format("YYYY-MM-DD") : maxDate || undefined;

    return (
      <div className={`date_range_filter ${className}`}>
        {label ? <label>{label}</label> : null}
        <div className="date_range_filter_form">
          <div className="form-group">
            <input
              type="date"
              id={startId}
              name="startDate"
              className="form-control"
              placeholder="yyyy-mm-dd"
              value={startDate}
              onChange={onStartDateChange}
              max={endDate || max}
            />
            <p>To</p>
            <input
              type="date"
              id={endId}
              name="endDate"
              className="form-control"
              placeholder="yyyy-mm-dd"
              value={endDate}
              onChange={onEndDateChange}
              min={startDate || undefined}
              max={max}
            />
          </div>
          {this.renderButton("find_btn", findLabel, onFind, canFind)}
          {this.renderButton("clear_btn", clearLabel, onClear, canClear)}
        </div>
      </div>
    );
  }
}

export default DateRangeFilter;
